import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum WorkspaceMembersColumn {
    USER = "user",
    ENTITIES = "entities",
    ROLE = "role",
    LAST_ACTIVE = "lastActive",
    ACTIONS = "actions",
}

const UserColumnSchema = ColumnSchema.extend({
    id: z.literal(WorkspaceMembersColumn.USER),
});
const EntitiesColumnSchema = ColumnSchema.extend({
    id: z.literal(WorkspaceMembersColumn.ENTITIES),
});
const RoleColumnSchema = ColumnSchema.extend({
    id: z.literal(WorkspaceMembersColumn.ROLE),
});
const LastActiveColumnSchema = ColumnSchema.extend({
    id: z.literal(WorkspaceMembersColumn.LAST_ACTIVE),
});
const ActionsColumnSchema = ColumnSchema.extend({
    id: z.literal(WorkspaceMembersColumn.ACTIONS),
});

export const WorkspaceMembersViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.WORKSPACE_MEMBERS),
    columns: z.array(
        z.discriminatedUnion("id", [
            UserColumnSchema,
            EntitiesColumnSchema,
            RoleColumnSchema,
            LastActiveColumnSchema,
            ActionsColumnSchema,
        ]),
    ),
});

export type WorkspaceMembersView = z.infer<typeof WorkspaceMembersViewSchema>;
